import { ApiErrorState } from './api-error.state';
import { createSelector, createFeatureSelector } from '@ngrx/store';

export const selectApiErrorState =
  createFeatureSelector<ApiErrorState>('apiError');

export const selectErrorResponse = createSelector(
  selectApiErrorState,
  (state: ApiErrorState) => state.errorResponse
);
